export default __webpack_public_path__ + "static/media/globe.2f84fa0b.svg";